import { toPriceList } from '@/api/mappers/mapPriceList';
import { toStatus } from '@/api/mappers/mapStatus';
import { toSupplier } from '@/api/mappers/mapSupplier';
import { PriceCreate as ApiPriceCreate, PriceUpdate as ApiPriceUpdate } from '@/gen/api';
import { Price as ApiPrice } from '@/gen/api/models/Price';
import { Amount, Price as PriceModel } from '@/models/Price';

export const toPrice = (apiPrice: ApiPrice): PriceModel => {
  return {
    ...apiPrice,
    status: apiPrice.status ? toStatus(apiPrice.status) : 'UNKNOWN',
    priceList: apiPrice.priceList ? toPriceList(apiPrice.priceList) : undefined,
    supplier: apiPrice.supplier ? toSupplier(apiPrice.supplier) : undefined,
  };
};

export function toApiPriceCreate(price: { price: Amount }): ApiPriceCreate {
  return { ...price };
}

export function toApiPriceUpdate(price: { price: Amount }): ApiPriceUpdate {
  return { ...price };
}
